import { render, staticRenderFns } from "./OrganizationDashboardPrograms.vue?vue&type=template&id=3f34a766&scoped=true&"
import script from "./OrganizationDashboardPrograms.vue?vue&type=script&lang=js&"
export * from "./OrganizationDashboardPrograms.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDashboardPrograms.vue?vue&type=style&index=0&id=3f34a766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f34a766",
  null
  
)

export default component.exports